module.exports = __webpack_public_path__ + "img/iotx.2fb42174.svg";